import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, MessagesSquare } from "lucide-react";
import Reveal from "./Reveal";

const QA = [
  {
    q: "Petře, jak se zrodil nápad naprogramovat vlastní AI kalkulačku KABUM PRO?",
    a: "Z potřeby nešidit řemeslo a neplýtvat. Odmítal jsem bojovat o zakázky podhodnocováním své práce. Místo toho jsem začal počítat materiál (hlavně složité sádrokartony) na milimetry přesně. Klientům jsem dal reálnou spotřebu bez zbytečné vaty. Ušetřili tak na rozpočtu klidně i desítky tisíc korun jen na nákupu. Zakázku jsem vyhrál a nemusel jsem slevovat z kvality.",
  },
  {
    q: "Jak těžké bylo naučit umělou inteligenci stavařinu?",
    a: "Ze začátku jsem se s tou umělou inteligencí hádal snad víc než se ženou! Já měl praxi, ona neuvěřitelně rychlé algoritmy, které bych sám nespočítal, ale občas jsme se míjeli. Musel jsem jí na fotkách a videích přímo ze stavby složitě vysvětlovat, že mi do rozpočtu nesmí počítat profily navíc, když už tam jedno UW nebo UD prostě namontované je. Piloval jsem ji dlouho a učím ji dál.",
  },
  {
    q: "Aplikaci chcete uvolnit zcela zdarma. Proč?",
    a: "Inspiruje mě navigace Waze. Je skvělá proto, že ji používají miliony lidí a sami ji vylepšují. S KABUM PRO chci to samé. Ať si aplikaci zkoušejí řemeslníci i běžní klienti. Chci, aby mi psali připomínky, a já ji budu dál ladit. Každý má právo transparentně vědět, kolik materiálu na svou rekonstrukci skutečně potřebuje.",
  },
  {
    q: "RESTART PRO je aliance. Podle čeho si lidi do party vybíráte?",
    a: "Základem jsou chlapi, se kterými dělám léta. Ale dobrého řemeslníka poznáte klidně za minutu. Nedávno jsem na stavbě potkal obkladače s fyzickým hendikepem ruky. Ta jeho práce byla tak precizní a on tak pracovitý, že strčil do kapsy většinu zdravých chlapů. Přesně takové lidi, kteří mají pro řemeslo cit, chci mít po boku.",
  },
  {
    q: "Na webu hodně mluvíte o domově a snech. Není to ve stavebnictví pořád hlavně o penězích?",
    a: "Samozřejmě, že nechci pracovat zadarmo. Ale ty peníze přijdou samy, když klienti vidí náš přístup. Lidé do bydlení dávají celoživotní úspory. K tomu nemůžete přistupovat jen jako k další faktuře. Pro mě je ten nejlepší pocit vidět upřímnou radost klienta z nového prostoru. Děláme práci, která nás neskutečně baví, za kterou dostaneme férově zaplaceno, a klientům při tom budujeme budoucnost. To dává ten správný smysl.",
  },
];

export default function Interview() {
  const [open, setOpen] = useState(0);

  return (
    <section id="rozhovor" data-testid="interview-section" className="py-24 lg:py-32 bg-ink">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4 flex items-center gap-2">
            <MessagesSquare size={14} /> Rozhovor se zakladatelem
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 leading-tight">
            Příběh za značkou — <span className="gold-text">zeptejte se Petra</span>
          </h2>
          <p className="mt-4 text-zinc-400 text-sm">
            Proč vznikl KABUM PRO, jak se učí umělá inteligence stavařinu a podle čeho vybíráme
            lidi do aliance.
          </p>
        </Reveal>

        <div className="mt-12 space-y-3">
          {QA.map((qa, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div
                className={`border rounded-xl overflow-hidden transition-colors duration-300 ${
                  open === i ? "border-gold/35 bg-card2" : "border-white/5 bg-card2/60 hover:border-gold/20"
                }`}
                data-testid={`interview-item-${i}`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  data-testid={`interview-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-4 p-6 text-left"
                >
                  <span className="text-zinc-100 font-semibold text-sm sm:text-base">{qa.q}</span>
                  <ChevronDown
                    size={18}
                    className={`text-gold shrink-0 transition-transform duration-300 ${
                      open === i ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-sm text-zinc-400 leading-relaxed">
                        <span className="text-gold-light font-semibold">Petr Lehnert: </span>
                        {qa.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
